import translations from './translations'

translations.add('en', {
    allPaymentsSecure: 'All payments secured by',
    poweredBy: 'Powered by'
})
